export const strings = {
  last_selected_branch_id: 'LAST_SELECTED_BRANCH_ID',
  basket_service_ids: 'BASKET_SERVICE_IDS',
  basket: 'BASKET',
  staff_basket: 'STAFF',
  nextBasket: 'NEXT_BASKET',
  customer_space_id: 'CUSTOMER_SPACE_ID',
  submit: 'ثبت سفارش',
  pendingPayment: 'در انتظار پرداخت',
  progressing: 'بررسی و تایید سفارش',
  preparation: 'در حال آماده سازی',
  processingCenter: 'خروج از آشپزخانه',
  deliveryDispatcher: 'تحویل به مأمور ارسال',
  delivered: 'تحویل به مشتری',
  canceled: 'لغو شده',
  canceledBySystem: 'لغو شده توسط سیستم',
  unknown: 'نامشخص'
};
